export default "__VITE_ASSET__DhEX6gQm__"